module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/product-images/fr-product-08-b3b630c30f97a4d7ee31e52c1be5cf28.jpg";